import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import { SortDir } from '@app/shared';
import { SortParameter } from '@shared/sort-selector/sort-parameter';

export const sortParameters: SortParameter[] = [
  {
    parameterName: 'name',
    label: 'A - Z',
    dir: SortDir.ASC
  },
  {
    parameterName: 'lastModifiedDate',
    label: 'Last Modified',
    dir: SortDir.DESC
  },
  {
    parameterName: 'createdDate',
    label: 'Creation Date',
    dir: SortDir.DESC
  }
];

@Component({
  selector: 'mojo-companies-sort-selector',
  templateUrl: './companies-sort-selector.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CompaniesSortSelectorComponent {
  sortParameters: SortParameter[] = sortParameters;

  @Input() sortBy: SortParameter;
  @Output() sortByChanged: EventEmitter<SortParameter> = new EventEmitter<
    SortParameter
  >();
}
